import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import useCreate from '../useCreate'
import toast from 'react-hot-toast'

const useDeleteCategory = () => {
    const { categoryId } = useParams()
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { setDataToServer } = useCreate({
        url: 'category/delete',
        refreshUrl: 'category/list',
        onSuccess: () => {
            // handleResetForm()
            toast.success("Category Deleted Successfully", {
                position: "top-right",
                duration: 3000
            })
            setTimeout(() => {
                window.location.reload()
            },2000)
        }
    })
    const handleSubmit = (data) => {
        setDataToServer.mutate(data)
    }

    return { handleSubmit,setDataToServer }
}

export default useDeleteCategory